import React from 'react';
import { Route, Routes } from 'react-router-dom';
import PrivateRoute from '../../common/components/router/PrivateRoute';
import { PERMISSIONS } from '../../common/constants';
import DefaultRates from '../../features/defaultRates/DefaultRates';
import DefaultRate from '../../features/defaultRates/DefaultRate';
import SeasonRates from '../../features/seasonRates/SeasonRates';
import EditSeasonRates from '../../features/seasonRates/EditSeasonRates';
import AddSeasonRate from '../../features/seasonRates/AddSeasonRate';
import UpdateSeasonRate from '../../features/seasonRates/UpdateSeasonRate';
import NotFound from '../../common/components/router/NotFound';
import CopySeasonRates from '../../features/seasonRateTools/CopySeasonRates';
import ChangeSeasonRatePrices from '../../features/seasonRateTools/ChangeSeasonRatePrices';
import ModifySeasonRatesTool from '../../features/seasonRateTools/ModifySeasonRatesTool';
import BlockedPeriods from '../../features/blockedPeriods/BlockedPeriods';
import AccommodationBlockedPeriods from '../../features/blockedPeriods/AccommodationBlockedPeriods';
import BlockedPeriodDetails from '../../features/blockedPeriods/BlockedPeriodDetails';
import ModifyAddonRulesTool from '../../features/seasonRateTools/ModifyAddonRulesTool';

const RateAppRoutes = () => (
  <Routes>
    <Route
      path="/defaultrates"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingRead]}>
          <DefaultRates />
        </PrivateRoute>
      }
    />
    <Route
      path="/defaultrate/:accommodationId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.PricingRead, PERMISSIONS.PricingModify]}
        >
          <DefaultRate writePermissions={[PERMISSIONS.PricingModify]} />
        </PrivateRoute>
      }
    />
    <Route
      path="/seasonrates"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingRead]}>
          <SeasonRates />
        </PrivateRoute>
      }
    />
    <Route
      path="/seasonrates/:accommodationId"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingRead]}>
          <EditSeasonRates writePermissions={[PERMISSIONS.PricingModify]} />
        </PrivateRoute>
      }
    />
    <Route
      path="/addseasonrate/:accommodationId"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingModify]}>
          <AddSeasonRate />
        </PrivateRoute>
      }
    />
    <Route
      path="/updateseasonrate/:accommodationId/:seasonRateId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.PricingRead, PERMISSIONS.PricingModify]}
        >
          <UpdateSeasonRate writePermissions={[PERMISSIONS.PricingModify]} />
        </PrivateRoute>
      }
    />
    <Route
      path="/blockedperiods"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingRead]}>
          <BlockedPeriods />
        </PrivateRoute>
      }
    />
    <Route
      path="/blockedperiods/:accommodationId"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingRead]}>
          <AccommodationBlockedPeriods />
        </PrivateRoute>
      }
    />
    <Route
      path="/blockedperiods/details/:blockedPeriodId"
      element={
        <PrivateRoute
          permissions={[PERMISSIONS.PricingRead, PERMISSIONS.PricingModify]}
        >
          <BlockedPeriodDetails />
        </PrivateRoute>
      }
    />
    <Route
      path="/ratetools/copyseasonrates"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingModify]}>
          <CopySeasonRates />
        </PrivateRoute>
      }
    />
    <Route
      path="/ratetools/changeseasonrateprices"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingModify]}>
          <ChangeSeasonRatePrices />
        </PrivateRoute>
      }
    />
    <Route
      path="/ratetools/modifyseasonratestool"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingModify]}>
          <ModifySeasonRatesTool />
        </PrivateRoute>
      }
    />
    <Route
      path="/ratetools/modifyaddonrulestool"
      element={
        <PrivateRoute permissions={[PERMISSIONS.PricingModify]}>
          <ModifyAddonRulesTool />
        </PrivateRoute>
      }
    />
    <Route path="*" element={<NotFound />} />
  </Routes>
);

export default RateAppRoutes;
